import deburr from 'lodash.deburr';
import { getNested, getVisibleElement, parseFetchResponse } from './helpers';
import { loadSubscriptionPlans } from './payment';

import validate from 'validate.js';

let userInfo = {};

let fieldIsValid = {
	name: false,
	email: false,
	password: false,
	terms: false,
	code: false,
	promo: true
};

function resetValidation() {
	userInfo = {};
	fieldIsValid = {
		name: false,
		email: false,
		password: false,
		terms: false,
		code: false
	};
}

function disableForm(form, stripeElement) {
	document.querySelectorAll(form + ' input').forEach(function(element) {
		element.setAttribute('disabled', true);
	});

	if (stripeElement) {
		stripeElement.update({ disabled: true });
	}
}

function enableForm(form, stripeElement) {
	document.querySelectorAll(form + ' input').forEach(function(element) {
		element.removeAttribute('disabled');
	});

	if (stripeElement) {
		stripeElement.update({ disabled: false });
	}
}

function userIsComplete() {
	gloValidate.fields(['name', 'email', 'password', 'terms']);

	return fieldIsValid.email && fieldIsValid.name && fieldIsValid.password && fieldIsValid.terms;
}

function paymentIsComplete() {
	return document.getElementById('register-form__card').classList.contains('StripeElement--complete');
}

function toggleSubmitButton(disabled, buttonText) {
	var elementClasses = [
		'#register-form__submit',
		'#register-form__code-submit',
		'.btn--purchase',
		'.reset-pw__submit',
		'.gift-purchase__purchase-btn'
	];

	elementClasses.forEach(function(className) {
		if (document.querySelector(className)) {
			document.querySelector(className).toggleAttribute('disabled', disabled);
			document.querySelector(className).value = buttonText;
		}
	});
}

function formatErrors(errors) {
	const options = {
		headers: {
			'Content-Type': 'application/json'
		},
		method: 'POST',
		body: JSON.stringify(errors)
	};

	fetch('/proxy/v1/formatErrors', options)
		.then(parseFetchResponse)
		.then(function(response) {
			response.forEach(function(error) {
				addError(error.param, error.msg);
			});
		});
}

function hasError(field) {
	if (!getVisibleElement('[name="' + field + '"]')) return false;
	return getVisibleElement('[name="' + field + '"]').classList.contains('form__input--error');
}

function removeError(field) {
	if (field === 'general') {
		var genericErrorsEl = document.querySelector('.form__generic-errors');

		if (genericErrorsEl) {
			genericErrorsEl.classList.add('hide');
			genericErrorsEl.innerHTML = '';
		}
	} else if (getVisibleElement('[name="' + field + '"]')) {
		getVisibleElement('[name="' + field + '"]').classList.remove('form__input--error');
		getVisibleElement('[name="' + field + '"]').parentElement.removeAttribute('data-error');
	}
}

function addError(field, msg) {
	var visibleField;

	// If the field has a period in it (i.e. `userInfo.email`),
	// let's just grab the last part of it (i.e. `email`)
	if (field && field.indexOf('.') > -1) field = field.split('.').pop();

	switch (field) {
		case 'amount':
			msg = 'Please specify an amount';
			break;

		case 'firstName':
		case 'lastName':
		case 'fullName':
		case 'buyerLastName':
			field = 'name';
			break;

		case 'recipientName':
			msg = 'Recipient\'s name is required';
			break;

		case 'recipientEmail':
			msg = 'Must be a valid email address';
			break;

		case 'agreedToTerms':
			field = 'terms';
			break;

		case 'invalid_request':
			// Reset the field/msg to default to the generic copy
			field = null;
			msg = null;
			break;
	}

	if (msg === 'Promo is no longer valid') field = 'code';

	if (msg && msg.includes('parameter should be an integer (instead, is NaN)') && msg.includes('exp_')) {
		msg = 'Invalid expiration';
	}

	visibleField = getVisibleElement('[name="' + field + '"]');

	// If no field/param is specified, let's return a "generic" error
	if (!field || !visibleField) {
		var visibleForm = getVisibleElement('form');
		var genericErrors;

		// If no message is defined, let's pass in a generic error
		if (!msg || msg.includes('stripe')) {
			msg = 'There was an error processing the form. Please try again!';
		}

		if (visibleForm) {
			genericErrors = visibleForm.querySelector('.form__generic-errors') || document.querySelector('.form-error');
		} else {
			var genericErrorsEls = document.querySelectorAll('.form__generic-errors');
			genericErrors = genericErrorsEls.length ? genericErrorsEls[genericErrorsEls.length - 1] : document.querySelector('.form-error');
		}

		genericErrors.innerHTML = msg;
		genericErrors.classList.remove('hide');
		return;
	}

	if (['exp_month', 'exp_year'].includes(field)) {
		document.getElementById('register-form__expiry--error').setAttribute('data-error', msg);
		return;
	}

	// If there is white space in the field, let's default to 'general'
	if (field.indexOf(' ') > -1) field = 'general';

	if (visibleField) visibleField.classList.add('form__input--error');

	if (Array.isArray(msg)) msg = msg.join(', ');

	// If a form error for this field doesn't already exist, let's add it
	if (visibleField) {
		visibleField.parentElement.setAttribute('data-error', msg);
	}
}

function promoCodeErrors(err, codeType) {
	var errors = err.errors || err;

	errors.forEach(function(error) {
		var errorMessage;

		if (error.msg === 'Promo code not found' || error.msg === 'Invalid giftToken - must be 40 characters long') {
			errorMessage = 'Hmm, we didn\'t recognize that ' + codeType + ' code.';
		} else if (error.msg === 'User must contact customer support to redeem promo code') {
			errorMessage = `It looks like your current subscription is managed by another service provider. Please contact us and we can help you redeem this ${codeType}.`;
		} else if (error.msg.includes('cannot redeem more than one promo code')) {
			// This error message contains a variable userID, bit more doing required
			errorMessage = `Sorry, you can't redeem more than one promo code.`;
		} else {
			errorMessage = error.msg;
		}

		addError('code', errorMessage);
	});
}

function replaceAccents(name) {
	return deburr(name);
}

function refineName(name) {
	var firstName, lastName;

	name = name.trim().replace(/\s\s+/g, ' '); // Trim whitespace and convert multiple spaces to one

	// Check for special characters and replace them if necessary
	if (/[À-ÿ.-]/.test(name)) name = replaceAccents(name);

	// If full name contains a space
	if (name.indexOf(' ') !== -1) {
		firstName = name.substr(0, name.indexOf(' ')).charAt(0).toUpperCase() + name.substr(0, name.indexOf(' ')).slice(1);
		lastName = name.substr(name.indexOf(' ') + 1).charAt(0).toUpperCase() + name.substr(name.indexOf(' ') + 1).slice(1);
	} else if (name) {
		firstName = name.charAt(0).toUpperCase() + name.substr(0, name.length).slice(1);
	}

	return { firstName, lastName };
}

const gloValidate = {
	name: function() {
		// First, let's correctly format the name values
		var value = document.querySelector('.register-form input[name="name"]').value;
		var refinedNameObj = refineName(value);

		userInfo.firstName = refinedNameObj.firstName;
		userInfo.lastName = refinedNameObj.lastName;

		var constraints = {
			firstName: {
				presence: {
					message: '^Please enter your full name'
				}
			},
		};

		var validationErrors = validate(userInfo, constraints);
		handleValidationErrors('name', validationErrors);
	},

	email: function() {
		var emailInput = 'input[name="email"]';
		var value = document.querySelectorAll(emailInput).length > 1 ? document.querySelector('.register-form ' + emailInput).value : document.querySelector(emailInput).value;

		userInfo.email = value;

		var constraints = {
			email: {
				presence: {
					message: '^Please enter an email address'
				},
				email: {
					message: '^Please enter a valid email address'
				}
			}
		};

		var validationErrors = validate(userInfo, constraints);
		handleValidationErrors('email', validationErrors);
	},

	password: function(confirm) {
		var passwordInput = 'input[name="password"]';
		var value = document.querySelectorAll(passwordInput).length > 1 ? getVisibleElement(passwordInput, true).value : document.querySelector(passwordInput).value;
		var passwordConstraints = document.getElementById('password-constraints').getAttribute('data-constraints');
		var field = confirm ? 'confirm-password' : 'password';
		var constraints;

		try {
			passwordConstraints = JSON.parse(passwordConstraints);
		} catch (err) { /* Fail silently */ }

		userInfo.password = value;

		validate.validators.checkEmail = window.checkEmail;

		try {
			passwordConstraints = JSON.parse(passwordConstraints);
			constraints = { password: passwordConstraints };
		} catch (err) {/* Fail silently */ }

		if (confirm) {
			var confirmPass = document.getElementById('confirm-password').value;

			constraints.password.inclusion = {
				within: [confirmPass],
				message: ' does not match'
			};
		}

		if (value) {
			var validationErrors = validate(userInfo, constraints);
			handleValidationErrors(field, validationErrors);
		} else {
			handleValidationErrors(field, {
				password: ['Please enter a password']
			});
		}
	},

	terms: function() {
		if (document.querySelector('.register-form input[name="terms"]').checked) {
			userInfo.agreedToTerms = true;
		} else {
			// Remove property from object entirely
			// Because we are only validating it's presence
			delete userInfo.agreedToTerms;
		}

		var constraints = {
			agreedToTerms: {
				presence: {
					message: '^You must agree to the terms'
				}
			}
		};

		var validationErrors = validate(userInfo, constraints);
		handleValidationErrors('terms', validationErrors);
	},

	// For code redemption-only forms
	code: function() {
		var value = document.querySelector('input[name="code"]').value;

		var constraints = {
			code: {
				presence: {
					message: '^Please enter a promo code'
				}
			}
		};

		var validationErrors = validate({ code: value }, constraints);
		handleValidationErrors('code', validationErrors);
	},

	// For registration forms
	promo: function() {
		var promo = document.querySelector('input[name="promo"]').value;
		var trimmedPromo = promo ? promo.trim() : '';

		removeError('promo');

		document.querySelector('.btn--apply-promo').toggleAttribute('disabled', !trimmedPromo);

		// If the user isn't redeeming a promo code, the field is valid
		if (!trimmedPromo.length) {
			fieldIsValid.promo = !trimmedPromo;
		}

		userInfo.promoCode = trimmedPromo;
	},

	fields: function(fields) {
		fields.forEach(function(field) {
			gloValidate[field]();
		});
	}
};

function handleValidationErrors(field, validationErrors) {
	var companyName = document.getElementById('company-name') ? document.getElementById('company-name').getAttribute('data-company-name') : null;

	removeError(field);
	fieldIsValid[field] = !validationErrors ? true : false;

	if (validationErrors) {
		for (var errorKey in validationErrors) {
			addError(field, validationErrors[errorKey]);
		}
	}

	// Logic to toggle company specific copy that overlaps with error messaging
	if (companyName && field === 'email') {
		var finePrintEl = document.querySelector('.register-form__input-fine-print');
		var emailError = getNested(validationErrors, 'email') ? validationErrors.email : null;

		finePrintEl.toggle(!emailError);
	}
}

function checkIfFormComplete(formName, isApplePay) {
	switch (formName) {
		case 'create-user':
			return userIsComplete();

		case 'guest-code-redemption':
			gloValidate.code();
			if (isApplePay) return fieldIsValid.code;
			return paymentIsComplete() && fieldIsValid.code;

		case 'code-redemption':
			gloValidate.code();
			return fieldIsValid.code;

		case 'gift':
			gloValidate.fields(['name', 'email', 'terms']);
			return paymentIsComplete() && fieldIsValid.terms && fieldIsValid.email && fieldIsValid.name;

		case 'register':
			if (!document.querySelector('input[name="promo"]').disabled) validatePromoCode();
			if (isApplePay) return fieldIsValid.promo;
			return paymentIsComplete() && fieldIsValid.promo;

		case 'reset-pw':
			var withConfirmation = true;
			gloValidate.password(withConfirmation);
			return fieldIsValid['confirm-password'];

		case 'payment':
			return paymentIsComplete();

		case 'nda':
			gloValidate.fields(['name', 'email', 'terms']);
			return fieldIsValid.email && fieldIsValid.name && fieldIsValid.terms;
	}
}

function validatePromoCode(attemptingApply, monthlyplanClicked) {
	removeError('promo');

	gloValidate.promo();

	var promo = userInfo.promoCode;
	var promoApplyButton = document.querySelector('.btn--apply-promo');

	if (promo.length) {
		promoApplyButton.setAttribute('disabled', true);

		// Must block in order to allow form validation methods
		// to receive a result
		fetch('/proxy/v1/validatePromo/' + promo)
			.then(parseFetchResponse)
			.then(function(response) {
				if (response.error) {
					if (response.error.message) {
						throw new Error(response.error.message);
					} else {
						throw new Error('Error applying promo code');
					}
				}

				fieldIsValid.promo = true;
				promoApplyButton.innerText = 'Applied!';
				promoApplyButton.removeAttribute('disabled');
				document.querySelector('input[name="promo"]').setAttribute('disabled', true);

				if (response.subscriptionPlans) {
					loadSubscriptionPlans(response.subscriptionPlans);
				}

				if (monthlyplanClicked) document.querySelector('.register-form__show-promo').click();
			})
			.catch(function(err) {
				if (monthlyplanClicked) {
					document.getElementById('register-form__promo').value = '';
				} else {
					var errMsg = err.toString().includes('Unauthorized')
						? 'There was an issue applying this promo code'
						: 'Promo code is invalid';

					fieldIsValid.promo = false;
					addError('promo', errMsg);
				}

				promoApplyButton.removeAttribute('disabled');
			});
	} else {
		// Allow empty promo codes only if the user isn't trying to
		// apply one
		if (attemptingApply) {
			addError('promo', 'You must enter a promo code');
		}

		promoApplyButton.removeAttribute('disabled');
	}
}

export {
	addError,
	checkIfFormComplete,
	disableForm,
	enableForm,
	fieldIsValid,
	formatErrors,
	gloValidate,
	handleValidationErrors,
	hasError,
	paymentIsComplete,
	promoCodeErrors,
	refineName,
	removeError,
	replaceAccents,
	resetValidation,
	toggleSubmitButton,
	userInfo,
	userIsComplete,
	validatePromoCode,
};
